<template>
  <div style="padding:5px 0">
    <div class="section operations">
      <div class="triggers">
        <div>
          <el-button v-show="false" :disabled="!isEditing" type="primary" no="1" @click="toQuery">{{ $t('common.btn.query') }}</el-button>
          <el-button :disabled="!isEditing" type="primary" no="2" @click="cloudFile.visible=true">{{ $t('CargoMsg.Cargo_Upload') }}</el-button>
          <el-button :disabled="!isEditing" type="danger" no="3" @click="remove">{{ $t('common.btn.delete') }}</el-button>
          <el-button :disabled="!isEditing" type="primary" no="4" @click="download">{{ $t('CargoMsg.Cargo_BatchDownload') }}</el-button>
        </div>
      </div>
    </div>
    <div class="section" style="flex: 1">
      <cargo-ag-grid
        config-module="23150203"
        :grid-options="gridOptions"
        :column-defs="columnDefs"
        :row-data="rowData"
        :grid-params.sync="gridParams"
        style="width:100%"
        no="5"
        @gridReady="params=>{gridApi=params.api}"
      />
    </div>
    <!-- 云文件上传对话框 -->
    <cargo-cloud-file-upload
      :visible.sync="cloudFile.visible"
      :job="cloudFile.job"
      :lob="cloudFile.lob"
      no="6"
      @uploadDone="toQuery"
    />
  </div>
</template>

<script>
import cargoCloudFileUpload from '@/components/Cargo/Common/cargoCloudFileUpload'
import URL from '@/api/urlTranslator'
import { getDocCategoryTypeTreeByLob } from '@/api/sysManage/baseConfig/docCategory'
import { getFileList, deleteFile } from '@/api/storage'
import { QuotationClient } from '@/class/model/sales/QuotationClient'
import { cache, cacheName } from '@/utils/cacheManager'
import DateUtils from '@/utils/dateUtils'

export default {
  name: 'TabCrmCustomerFile',
  components: { cargoCloudFileUpload },
  props: {
    context: {
      type: Object,
      required: true
    },
    action: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      quotationClient: new QuotationClient().fillDefaultValue().getData(),
      storageURL: '',
      fileTypeMap: new Map(),
      gridOptions: {
        rowSelection: 'multiple',
        suppressCellSelection: true,
        context: {
          componentParent: this
        }
      },
      columnDefs: [
        {
          headerName: '',
          field: '',
          width: 65,
          headerCheckboxSelection: true,
          checkboxSelection: true,
          sortable: false,
          suppressMenu: true,
          suppressSizeToFit: true,
          resizable: false
        },
        {
          headerName: this.$t('CargoMsg.Cargo_FileName'),
          field: 'fileName',
          width: 200
        },
        {
          headerName: this.$t('CargoMsg.Cargo_FileType'),
          field: 'fileType',
          width: 200,
          cellRenderer: params => {
            return this.fileTypeMap.get(params.value.toUpperCase()) || this.$t('Sales.Other')
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_FileFormat'),
          field: 'fileFormat',
          width: 200
        },
        {
          headerName: this.$t('CargoMsg.Cargo_FileSize'),
          field: 'fileSize',
          width: 200,
          cellRenderer: params => {
            return params.value ? (params.value / 1024).toFixed(2) + 'KB' : ''
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_ViewFile'),
          field: 'fileId',
          suppressMenu: true,
          width: 200,
          cellRenderer: params => {
            return `<a href="${URL.common.findByFileId}/${params.value}?sessionId=${this.$store.getters.userInfo.sessionId}" target="_blank" style="color:#46a6ff">${this.$t('FileHistory.view')}</a>`
          }
        }
      ],
      rowData: [],
      gridParams: {},
      gridApi: null,
      cloudFile: {
        visible: false,
        job: new QuotationClient(),
        lob: 'PT'
      }
    }
  },
  computed: {
    readonly() {
      return !this.isEditing
    },
    isEditing() {
      return this.action !== 'look'
    }
  },
  async created() {
    await getDocCategoryTypeTreeByLob({ constructLobParent: false, lob: this.cloudFile.lob }).then(res => {
      res.data.forEach(item => {
        if (item.type === 2) {
          this.fileTypeMap.set(item.code.toUpperCase(), item.chineseName)
        }
      })
    })
  },
  methods: {
    onShow(row, isRefresh) {
      if (isRefresh) {
        this.quotationClient = row
        this.cloudFile.job = new QuotationClient(row)
        this.toQuery()
      }
    },
    async toQuery() {
      await cache.load(cacheName.CONFIG)
      this.storageURL = cache.config.get('StorageURL')
      const ajaxResults = [
        getFileList(
          '<RequestObject><data><extendMetaData><entry><key>companyKey</key><value>' +
          this.cloudFile.job.uuid +
          '</value></entry></extendMetaData></data></RequestObject>'
        )
      ]
      if (this.cloudFile.job.companyUuid) {
        ajaxResults.push(
          getFileList(
            '<RequestObject><data><extendMetaData><entry><key>companyKey</key><value>' +
            this.cloudFile.job.companyUuid +
            '</value></entry></extendMetaData></data></RequestObject>'
          )
        )
      }
      await Promise.all(ajaxResults).then(results => {
        const data = results[0].data
        if (results.length > 1) {
          data.push(...results[1].data)
        }
        this.rowData = Array.from(data, p => {
          return {
            fileId: p.id,
            fileName: p.fileName,
            fileType: p.extendMetaData.documentType || '',
            fileFormat: p.fileType.split(';')[0],
            fileSize: p.fileSize
          }
        })
      })
    },
    remove() {
      const rows = this.gridApi.getSelectedRows()
      if (rows.length === 0) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelectFile'))
        return
      }
      this.$confirm(this.$t('CargoMsg.Cargo_AYSDF'), this.$t('common.tips.prompt'), {
        confirmButtonText: this.$t('common.btn.ok'),
        cancelButtonText: this.$t('common.btn.cancel'),
        closeOnClickModal: false,
        type: 'warning'
      }).then(async() => {
        let count = 0
        try {
          for (const item of rows) {
            const isSuccess = await deleteFile(item.fileId).then(res => res.data === 'success')
            if (isSuccess) {
              count++
              item.isDeleted = true
            } else {
              count = 0
              this.$message.error(this.$t('CargoMsg.Cargo_ERF'))
              break
            }
          }
        } finally {
          if (count > 0) this.$message.success(this.$t('CargoMsg.Cargo_FDS'))
          this.rowData = this.rowData.filter(p => !p.isDeleted)
        }
      }).catch(() => { })
    },
    download() {
      const rows = this.gridApi.getSelectedRows()
      if (!rows || rows.length === 0) {
        this.$message.warning(this.$t('CargoMsg.Cargo_SelectFilesToDownload'))
        return
      }
      const dateNum = DateUtils.customFormat(new Date(), 'YYYYMMDDkkmmss')
      const fileIds = Array.from(rows, p => p.fileId).join(',')
      const fileName = dateNum + '.zip'
      window.open(`${URL.common.compressFiles}?sessionId=${this.$store.getters.userInfo.sessionId}&fileIds=${fileIds}&fileName=${fileName}`)
    }
  }
}
</script>
<style lang="scss">
</style>
